import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import { QuoteGroupData } from '../quote-groups/QuoteGroupData';
import { makeValidable } from '@ami/react/core';
import { quoteGroupsServices } from '../quote-groups/quoteGroupsServices';
import { QuoteGroup } from '../quote-groups/quoteGroup';
import { DealerGroup } from '../dealer-groups/dealerGroup';

const ValidableQuoteGroupData = makeValidable(QuoteGroupData);

export default class QuoteGroupAddModal extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();
    this.save = this.save.bind(this);
    this.hide = this.hide.bind(this);
  }

  static propTypes = {
    dealerGroupId: PropTypes.string.isRequired,
    title: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    onNewQuoteGroupCreated: PropTypes.func.isRequired,
    dealerContactId: PropTypes.string,
  };

  state = {
    submitting: false,
    entity: new QuoteGroup(),
    showValidations: false,
    hasBeenLoaded: false,
  };

  async componentDidUpdate(prevProps) {
    if (
      (!prevProps.showModal &&
        this.props.showModal &&
        !this.state.hasBeenLoaded) ||
      prevProps.dealerGroupId !== this.props.dealerGroupId ||
      prevProps.dealerContactId !== this.props.dealerContactId
    ) {
      const { entity } = this.state;
      var dealerGroup = await DealerGroup.getById(this.props.dealerGroupId);
      entity.dealerGroupId = this.props.dealerGroupId;
      entity.dealerGroupName = dealerGroup.name;
      entity.dealerContactId = this.props.dealerContactId;
      this.setState({ entity, hasBeenLoaded: true });
    }
  }

  save() {
    this.setState({ showValidations: true }, () => {
      if (this.validableRef.current.isValid()) {
        this.setState({ submitting: true });
        quoteGroupsServices
          .create(this.state.entity, false)
          .then((createdQuoteGroup) => {
            this.props.onNewQuoteGroupCreated(createdQuoteGroup);
            this.hide();
          })
          .catch(() => this.setState({ submitting: false }));
      }
    });
  }

  hide() {
    const { entity } = this.state;
    this.setState({ submitting: false }, () => {
      this.props.hideModal();
    });
    this.setState({
      entity: new QuoteGroup({
        name: '',
        dealerGroupId: entity.dealerGroupId,
        dealerGroupName: entity.dealerGroupName,
      }),
    });
  }

  render() {
    const { title, showModal } = this.props;

    const { submitting, entity, showValidations, hasBeenLoaded } = this.state;
    return (
      <Modal
        title={`Add ${title}`}
        show={showModal}
        showCancel={true}
        onOk={this.save}
        onCancel={this.hide}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        submitting={submitting}
        closeOnOk={false}
        okTitle={'Add Quote Group'}
      >
        {hasBeenLoaded && (
          <ValidableQuoteGroupData
            ref={this.validableRef}
            showValidations={showValidations}
            entity={entity}
            onUpdate={(entity) => this.setState({ entity })}
            disabled={false}
          />
        )}
      </Modal>
    );
  }
}
